import frcophth1Img from "../assets/course-cards/frcophth-part-1.jpg";
import frcophth2Img from "../assets/course-cards/frcophth-part-2.jpg";
import certlrsImg from "../assets/course-cards/certlrs.jpg";
import icoPartAImg from "../assets/course-cards/ico-part-a.jpg";
import icoPartBImg from "../assets/course-cards/ico-part-b.jpg";
import icoPartCImg from "../assets/course-cards/ico-part-c.jpg";
import msraImg from "../assets/course-cards/msra.jpg";
import mrcgpImg from "../assets/course-cards/mrcgp.jpg";
import interviewPackSt1Img from "../assets/course-cards/interview-pack-st1.jpg";
import dukeElderImg from "../assets/course-cards/duke-elder.jpg";
import interviewCoachingImg from "../assets/products/interview-coaching.jpg";
import portfolioBuilderImg from "../assets/products/portfolio-builder.jpg";
import bioImg from "../assets/course-cards/biology.jpg";
import mathsImg from "../assets/course-cards/maths.jpg";
import chemistryImg from "../assets/course-cards/chemistry.jpg";
import physicsImg from "../assets/course-cards/physics.jpg";

const PRODUCT_CARD_IMAGES_BY_ID: Record<string, string> = {
  frcophth1: frcophth1Img,
  frcophth2: frcophth2Img,
  certlrs: certlrsImg,
  ico_part_a: icoPartAImg,
  ico_part_b: icoPartBImg,
  ico_part_c: icoPartCImg,
  msra: msraImg,
  mrcgp: mrcgpImg,
  mrcgp_akt: mrcgpImg,
  interview_pack_st1: interviewPackSt1Img,
  duke_elder: dukeElderImg,
  interview_coaching: interviewCoachingImg,
  portfolio_builder: portfolioBuilderImg,
};

const PRODUCT_CARD_IMAGES_BY_SUBJECT_NAME: Record<string, string> = {
  Maths: mathsImg,
  Mathematics: mathsImg,
  Biology: bioImg,
  Chemistry: chemistryImg,
  Physics: physicsImg,
  "FRCOphth Part 1": frcophth1Img,
  "FRCOphth Part 2 (Written)": frcophth2Img,
  "FRCOphth Part 2": frcophth2Img,
  CertLRS: certlrsImg,
  "ICO Part A": icoPartAImg,
  "ICO Part B": icoPartBImg,
  "ICO Part C": icoPartCImg,
  MSRA: msraImg,
  MRCGP: mrcgpImg,
  "MRCGP AKT": mrcgpImg,
  "Interview Pack (ST1)": interviewPackSt1Img,
  "Duke Elder": dukeElderImg,
  "Interview Coaching": interviewCoachingImg,
  "Portfolio Builder": portfolioBuilderImg,
};

export function getProductCardImageById(productId: string): string | undefined {
  return PRODUCT_CARD_IMAGES_BY_ID[productId];
}

export function getProductCardImageBySubjectName(subjectName: string): string | undefined {
  return PRODUCT_CARD_IMAGES_BY_SUBJECT_NAME[subjectName];
}

/** Resolve a dashboard/enrolment card image from subject and/or class names. */
export function getProductCardImage(...names: Array<string | undefined | null>): string | undefined {
  for (const name of names) {
    if (!name) continue;
    const trimmed = name.trim();
    const direct = PRODUCT_CARD_IMAGES_BY_SUBJECT_NAME[trimmed];
    if (direct) return direct;
  }
  return undefined;
}

